// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileExcelOutlinedSvg from "@fishx/icons-svg/es/asn/FileExcelOutlined";
import FishxIcon from '../components/FishxIcon';

var FileExcelOutlined = function FileExcelOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileExcelOutlinedSvg
  }));
};

FileExcelOutlined.displayName = 'FileExcelOutlined';
export default React.forwardRef(FileExcelOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FileExcelOutlined.js
// module id = 2689
// module chunks = 0